"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _get2 = _interopRequireDefault(require("lodash/get"));

var _httpClient = _interopRequireDefault(require("../httpClient"));

var site = process.env.IS_BROWSER && (0, _get2.default)(window || {}, '__INITIAL_STATE__.config.appName', '').indexOf('office') >= 0 ? 'office-app' : 'member-app';
var authService = {
  // Logs in a user
  login: function login(email, password) {
    return _httpClient.default.post('/gateway/platform/v1/session/login', {
      body: {
        identifier: email,
        token: password
      }
    });
  },
  // Log out a user
  logout: function logout(userId) {
    return _httpClient.default.post('/gateway/platform/v1/session/logout', {
      body: {
        userId: Number(userId)
      }
    });
  },
  // Request user's password reset
  requestPasswordReset: function requestPasswordReset(email) {
    return _httpClient.default.post('/gateway/platform/v1/password/sendResetEmail', {
      body: {
        email: email,
        site: site
      }
    });
  },
  resetPassword: function resetPassword(resetId, newPassword) {
    return _httpClient.default.post('/gateway/platform/v1/password/resetByToken', {
      body: {
        password: newPassword,
        token: resetId
      }
    });
  },
  getPasswordResetInfo: function getPasswordResetInfo(resetId) {
    return _httpClient.default.get("/gateway/platform/v1/password/checkResetToken/".concat(resetId));
  },
  resetPasswordAndLogin: function resetPasswordAndLogin(resetId, newPassword) {
    return _httpClient.default.post('/gateway/platform/v1/password/resetAndLogin', {
      body: {
        password: newPassword,
        token: resetId
      }
    });
  },
  sendMagicLink: function sendMagicLink(applicationName, path, email, payload) {
    return _httpClient.default.post('/gateway/platform/v1/magiclink/login/send', {
      body: {
        applicationName: applicationName,
        path: path,
        email: email,
        payload: payload
      }
    });
  },
  validateMagicLink: function validateMagicLink(magicToken) {
    return _httpClient.default.post('/gateway/platform/v1/magiclink/login', {
      body: {
        magicToken: magicToken
      }
    });
  }
};
var _default = authService;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-app-platform/lib/common/auth/authService.js
// module id = 3460
// module chunks = 25